import { ProjectArtifactsTab } from "@/components/projects/project-artifacts-tab.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId/artifacts",
)({
	component: ProjectArtifactsTab,
});
